import { Button, NumberBox, Toolbar } from "devextreme-react";
import { Item } from "devextreme-react/toolbar";
import { useEffect, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import { useSelector } from "react-redux";

export default function AuditDocumentPDFViewer(props) {
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  const { opened } = props;

  const selectedDoc = useSelector(
    (state) => state.auditDocumentViewer.selectedDoc
  );
  const userInfo = useSelector((state) => state.userInfo);

  const [pageNumber, setPageNumber] = useState(1);
  const [numPages, setNumPages] = useState(null);
  const [scale, setScale] = useState(1.3);

  useEffect(() => {
    const cancelEvent = (e) => {
      e.preventDefault();
    };

    const printScreen = (e) => {
      if (e.key === "PrintScreen") {
        navigator.clipboard.writeText("");
      }
    };

    document.addEventListener("selectstart", cancelEvent);
    document.addEventListener("dragstart ", cancelEvent);
    document.addEventListener("keyup", printScreen);
    return () => {
      document.removeEventListener("selectstart", cancelEvent);
      document.removeEventListener("dragstart", cancelEvent);
      document.removeEventListener("keyup", printScreen);
    };
  }, []);

  useEffect(() => {
    setPageNumber(1);
    setScale(1.3);
  }, [selectedDoc]);

  const onClickBefore = () => {
    if (pageNumber > 1) {
      setPageNumber(pageNumber - 1);
    }
  };

  const onClickRight = () => {
    if (pageNumber < numPages) {
      setPageNumber(pageNumber + 1);
    }
  };

  const onChangePageNumber = (e) => {
    setPageNumber(Number(e.event.target.value));
  };

  const onClickAdd = () => {
    setScale(scale * 1.1);
  };

  const onClickMinus = () => {
    setScale(scale / 1.1);
  };

  const onLoadSuccess = ({ numPages }) => [setNumPages(numPages)];

  const onContextMenu = (e) => e.preventDefault();

  if (selectedDoc) {
    return (
      <div style={{ width: "100%", overflow: "auto" }}>
        <Toolbar>
          <Item location={"before"}>
            <Button
              icon="arrowleft"
              style={{ backgroundColor: "#f5f5f5" }}
              onClick={onClickBefore}
            />
          </Item>
          <Item location={"before"}>
            <Button
              icon="arrowright"
              style={{
                backgroundColor: "#f5f5f5",
              }}
              onClick={onClickRight}
            />
          </Item>
          <Item location={"before"}>
            <div
              style={{
                width: "30px",
                fontSize: "30px",
                color: "#f5f5f5",
                textAlign: "center",
              }}
            ></div>
          </Item>
          <Item location={"before"}>
            <NumberBox
              value={pageNumber}
              width={50}
              min={1}
              max={numPages}
              onChange={onChangePageNumber}
            />
          </Item>
          <Item location="before" text={` / `} />
          <Item location="before" text={numPages} />
          <Item location={"before"}>
            <div
              style={{
                width: "30px",
                fontSize: "30px",
                color: "#f5f5f5",
                textAlign: "center",
              }}
            ></div>
          </Item>
          <Item location={"before"}>
            <Button
              icon="add"
              style={{ backgroundColor: "#f5f5f5" }}
              onClick={onClickAdd}
            />
          </Item>
          <Item location={"before"}>
            <Button
              icon="minus"
              style={{ backgroundColor: "#f5f5f5" }}
              onClick={onClickMinus}
            />
          </Item>
        </Toolbar>
        <div
          style={{
            overflow: "auto",
            borderTop: "1px solid #e0e0e0",
            maxHeight: "calc(100vh - 200px)",
          }}
        >
          <Document
            className="document"
            file={{
              // url: `https://betree.beccocro.com:9000/api/adtDocV/${selectedDoc.docNo}`,
              url: `${process.env.REACT_APP_BECCO_API_URL}/api/adtDocV/${selectedDoc.docNo}`,
              withCredentials: true,
            }}
            onLoadSuccess={onLoadSuccess}
            onContextMenu={onContextMenu}
          >
            <div
              className="watermarked"
              data-watermark={(
                userInfo.email +
                " " +
                new Date().toISOString() +
                " "
              ).repeat(300)}
            >
              <Page pageNumber={pageNumber} scale={scale} className="page" />
            </div>
          </Document>
        </div>
      </div>
    );
  } else {
    return <div />;
  }
}
